import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";

import { useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";

const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

const MAINNET_CHAIN_ID = 1;

// ---- CONFIG ----
const DOS_CONTRACT_ADDRESS = "0xDEBc06Cb843d36714a13C1Cb6cde49C168F5C7fb"; // mainnet DOS
const SATOSHI_DUDE_ID = 0; // cypherdude #0
const SATOSHI_SLOT_ID = 0; // slot #0
// ----------------

// claimSlot(uint256,uint256) -> 0x74cde9ac
const dosAbi = ["function claimSlot(uint256 _dudeId, uint256 slotId)"];

const SatoshiMint = () => {

    const navigate = useNavigate();
    const [txStatus, setTxStatus] = useState('');

    const { chainId, isConnected } = useWeb3ModalAccount();
    const { walletProvider } = useWeb3ModalProvider();

    const checkConnection = () => {
        if (!isConnected) {
            alert('connect your wallet');
            return false;
        }
        if (Number(chainId) !== MAINNET_CHAIN_ID) {
            alert('switch to ethereum mainnet');
            return false;
        }
        return true;
    }

    const _satoshiMint = async () => {
        if (!checkConnection()) return;
        try {
            setTxStatus('Claim initiated...');
            const provider = new ethers.BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            const dos = new ethers.Contract(DOS_CONTRACT_ADDRESS, dosAbi, signer);
            const tx = await dos.claimSlot(SATOSHI_DUDE_ID, SATOSHI_SLOT_ID);
            setTxStatus('Transaction sent : ' + tx.hash);
            const receipt = await tx.wait();
            if (receipt.status === 0) {
                setTxStatus('transaction failed');
                throw new Error("transaction failed");
            }
            setTxStatus('Slot #' + SATOSHI_SLOT_ID + ' claimed for cypherdude #' + SATOSHI_DUDE_ID);
            setTimeout(() => navigate('/dos'), 1000);
        } catch (error) {
            if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
                setTxStatus('Transaction canceled by the user');
                return;
            }
            setTxStatus('Transaction failed : ' + (error.reason || error.message));
            console.log(error);
        }
    }

    return (
        <div className="mint" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh'
        }}>
            <button
                className="uxBtn"
                onClick={_satoshiMint}
                style={{ fontSize: '3rem', padding: '2rem 4rem' }}>
                Satoshi Mint
            </button>
            {txStatus && <p style={{ color: '#00ff00', marginTop: '2rem', textAlign: 'center' }}>{txStatus}</p>}
        </div>
    )
}

export default SatoshiMint;
